import { render, staticRenderFns } from "./aa.vue?vue&type=template&id=ba7563c6&scoped=true&"
import script from "./aa.vue?vue&type=script&lang=js&"
export * from "./aa.vue?vue&type=script&lang=js&"
import style0 from "./aa.vue?vue&type=style&index=0&id=ba7563c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba7563c6",
  null
  
)

export default component.exports